import api from "../api"

export const createInvoiceValidation = (data) => {
    return api.makeAuthRequest({
        url: `requests`,
        method: 'POST',
        data: data
    })
}